import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid} from '@material-ui/core';
import {Stack} from '@mui/material';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';
import { makeStyles } from '@material-ui/core/styles';
import Header from "./HeaderMy";
import LeftDrawer from "../components/LeftDrawer";
import NotificationAlerts from "../components/NotificationAlerts";
import '../styles/bizofficer-a.css';

const useStyles = makeStyles((theme) => ({
	content: {
	  [theme.breakpoints.up('md')]: {
		marginLeft:240,
		marginTop:60,
	  },
	  padding: theme.spacing(1),
	},
  }));  
  
const columns = [
	{ field: 'id', headerName: 'No.', type: 'number', width: 40 },
	{ field: 'courseName', headerName: 'Course Name', width: 240 },
	{ field: 'amount', headerName: 'Amount', flex: 1 },
	{ field: 'referenceNumber', headerName: 'Reference Number', flex: 1 },
	{ field: 'createdDateTime', headerName: 'Date', width: 160 }
	/*
	{
	  field: 'age',
	  headerName: 'Age',
	  type: 'number',
	  width: 130,
	},
	{
	  field: 'fullName',
	  headerName: 'Full name',
	  description: 'This column has a value getter and is not sortable.',
	  sortable: false,
	  width: 160,
	  valueGetter: (params) =>
		`${params.getValue(params.id, 'firstName') || ''} ${
		  params.getValue(params.id, 'lastName') || ''
		}`,
	},
	*/
  ];
  
  export default function Execute() {
	const classes = useStyles();
	const [rows, setRows] = React.useState([]);
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));

	const authResult = new URLSearchParams(window.location.search);
	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	React.useEffect(() => {
		setRows([]);
		getApiData();	
	}, []); // testId currentQuestion (Math.floor(Math.random() * 10) + 1)

	async function getApiData(){
		let axiosHeader = {
			headers:{
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};
			axios.get(API_URL+'/paymenttransactions', axiosHeader)
			   .then(response => {
			 	if(response && response.data && response.data.responseTxt==="success"){  
				 	if(response.data.obj && response.data.obj.length>0){
						setRows(response.data.obj);
					}
				}else if(response && response.data && response.data.responseTxt==="invalidToken"){
					window.localStorage.removeItem('etlStudentObj');  
					window.localStorage.clear(); 
					window.location.href='logout';
				 
				}

			})
	}

	// function goToDetail(obj){
	// 	if(obj && rows[obj.id-1]){
	// 		///window.location.href="testsimulator?testId="+rows[obj.id-1].testSessionId;
	// 	}
	// }

	return (
		<div> 
				<MetaTags>
            		<title>Payments</title>
          		</MetaTags>				
				<Header />	
	   			<LeftDrawer />
			<main className={classes.content}>
        	<NotificationAlerts />
			
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>	

					<Box mt={1}>
							<Grid container spacing={2}>
								<Grid item md={12} xs={12}>
									<h3 className="heading" >Payments</h3>
									{/* <h4 style={{color:'#f50057'}}>Click on any row for details</h4> */}
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '200vh', width: '100%' }}>
						<DataGrid
							rows={(rows || [])}
							columns={columns}
							pageSize={50}
							rowsPerPageOptions={[50]}		
							style={{fontSize:12}}	
							components={{
								NoRowsOverlay: () => (
								  <Stack style={{marginTop:150}} alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No payment found!</span>
								  </Stack>
								)}}	
						/>

						{/* onRowClick={itm => goToDetail(itm)}			 */}

					</div>

				</Box>
			</main>						
		</div>	
	);
  }